'use strict';

import angular from 'angular';

export default angular
  .module('app.btnPrimary', [])
  .directive('btnPrimary', btnDirective => {
    'ngInject';

    return Object.assign({}, btnDirective[0], {
      template: `
        <button class="btn" type="button" theme="primary" ng-class="btnClasses" ng-transclude></button>
      `
    });
  }).name;
